<template>
	<div class="metric-box">
		<div>
			<slot></slot>
		</div>
		<div v-if="view === 'metric'">
			<h3 v-if="type == 'money'" class="is-inline-block">
				{{ $filters.Currency($store.getters.user.Currency, current) }}
			</h3>
			<h3 v-else class="is-inline-block">{{ nformat(current) }}</h3>
			<span v-if="compare.length">
				<o-icon icon="long-arrow-up" pack="fas" class="success" v-if="change > 0"></o-icon>
				<o-icon icon="minus" pack="fas" class="neutral" v-if="change == 0"></o-icon>
				<o-icon icon="long-arrow-down" pack="fas" class="danger" v-if="change < 0"></o-icon>
				<span :class="{ success: change > 0, neutral: change == 0, danger: change < 0 }">
					{{ $filters.Percentage(change) }}
				</span>
			</span>
		</div>
		<div class="is-flex is-justify-content-space-between" v-if="view === 'plain'">
			<div>
				<slot name="description"></slot>
			</div>
			<div>
				<o-icon icon="long-arrow-up" pack="fas" class="success" v-if="change > 0"></o-icon>
				<o-icon icon="minus" pack="fas" class="neutral" v-if="change == 0"></o-icon>
				<o-icon icon="long-arrow-down" pack="fas" class="danger" v-if="change < 0"></o-icon>
				{{ nformat(current - previous) }}
				<slot name="descriptor">Items</slot>
			</div>
		</div>
		<div v-if="report && metric">
			<kpi
				:report="report"
				:breakdown="breakdown"
				:metric="metric"
				:config="{ segment: includeSegment }"></kpi>
		</div>
	</div>
</template>
<script>
	import { ref, computed, onMounted, inject } from "vue";
	import { currencyFormat, numberFormat } from "@/services/utils";
	import kpi from "@/components/webComponents/charts/kpi.vue";

	export default {
		components: { kpi },
		props: {
			metric: {
				type: String,
				default: ""
			},
			breakdown: {
				type: Object,
				default: () => {
					return undefined;
				}
			},
			results: {
				type: Array,
				default: () => {
					return [];
				}
			},
			compare: {
				type: Array,
				default: () => {
					return [];
				}
			},
			type: {
				type: String,
				default: "money"
			},
			view: {
				type: String,
				default: "metric"
			},
			report: {
				type: Object,
				default: undefined
			},
			includeSegment: {
				type: Boolean,
				default: true
			}
		},
		setup(props, context) {
			const $financial = inject("$financial");

			const cformat = ref(currencyFormat.format);
			const nformat = ref(numberFormat.format);
			const pformat = ref(numberFormat.percent);

			const getBreakdownFilteredRows = (rows) => {
				if (!rows || rows.length === 0) return [];
				if (props.breakdown?.api?.BreakdownFilterResults) {
					return props.breakdown.api.BreakdownFilterResults(rows);
				}
				return rows;
			};

			const getFilledJobValue = (isCompare) => {
				const reportRows = isCompare ? props.report?.compare : props.report?.results;
				const aggregateRows = isCompare ? props.compare : props.results;
				if (reportRows && reportRows.length > 0) {
					const rows = getBreakdownFilteredRows(reportRows);
					return isCompare
						? $financial.compare.getFilledJobValue(rows)
						: $financial.getFilledJobValue(rows);
				}

				const total = aggregateRows.reduce((acc, row) => {
					return acc + row[props.metric];
				}, 0);
				return total / (aggregateRows.filter((row) => row[props.metric] != 0).length || 1);
			};

			const current = computed(() => {
				if (props.metric == "filledJobValue") return getFilledJobValue(false);
				if (props.results.length == 0) return 0;

				let total = 0;
				if (props.metric == "teamingValue") return props.results[0]["teamingValue_metric"];

				total = props.results.reduce((acc, row) => {
					return acc + row[props.metric];
				}, 0);

				return total || 0;
			});

			const previous = computed(() => {
				if (props.metric == "filledJobValue") return getFilledJobValue(true);
				if (props.compare.length == 0) return 0;

				let total = 0;
				if (props.metric == "teamingValue") return props.compare[0]["teamingValue_metric"];

				total = props.compare.reduce((acc, row) => {
					return acc + row[props.metric];
				}, 0);

				return total || 0;
			});

			const change = computed(() => {
				if (current.value === 0 && previous.value === 0) {
					return 0;
				} else if (previous.value === 0) {
					return 1;
				} else if (current.value === 0) {
					return previous.value > 0 ? -1 : 1;
				}

				return (current.value - previous.value) / Math.abs(previous.value);
			});

			return {
				cformat,
				nformat,
				pformat,
				current,
				previous,
				change
			};
		}
	};
</script>
<style lang="scss" scoped>
	@use "@/assets/css/globalVars.scss" as *;

	.metric-box {
		& .success {
			color: $boyden-green;
		}
		& .danger {
			color: $boyden-red;
		}
		& .neutral {
			color: #ddd;
		}
	}

	// .metric-box {
	// 	border-left: solid 4px #ddd;
	// 	padding: 0 2em 0 1em;

	// 	&.success {
	// 		// border-left: solid 4px #508D36;
	// 		border-left: solid 4px $boyden-green;
	// 	}
	// 	&.danger {
	// 		//border-left: solid 4px #C91B24;
	// 		border-left: solid 4px $boyden-red;
	// 	}

	// 	& .icon {
	// 		color: #ddd;

	// 		&.success {
	// 			color: $boyden-green;
	// 		}
	// 		&.danger {
	// 			color: $boyden-red;
	// 		}
	// 	}

	// 	& .help {
	// 		line-height: 0.6;
	// 	}
	// }
</style>
